export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">黑料网下载</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              全网领先的黑料视频在线观看平台，提供最新最全的黑料网在线观看服务。无需下载即点即看，每日更新最新吃瓜内容，致力于成为用户首选的<strong className="text-background-50">黑料在线看片</strong>平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-telegram-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base font-heading font-bold text-background-50 mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '热门视频', href: '#media' },
                { label: '最新黑料', href: '#cards' },
                { label: '话题热榜', href: '#topics' },
                { label: '投稿爆料', href: '#contact' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-base font-heading font-bold text-background-50 mb-4">内容分类</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                '娱乐圈八卦',
                '网红直播',
                '社会热点',
                '综艺内幕',
                '商界风云',
                '体坛爆料',
              ].map((label) => (
                <a
                  key={label}
                  href="#index"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-base font-heading font-bold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed mb-3">
              黑料网下载与多家内容平台和媒体机构保持合作关系，共同为用户提供优质的<strong className="text-foreground-300">黑料视频在线播放</strong>内容。
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1.5 rounded-lg bg-foreground-800 text-foreground-400 text-xs">合作站点A</span>
              <span className="px-3 py-1.5 rounded-lg bg-foreground-800 text-foreground-400 text-xs">合作站点B</span>
              <span className="px-3 py-1.5 rounded-lg bg-foreground-800 text-foreground-400 text-xs">合作站点C</span>
              <span className="px-3 py-1.5 rounded-lg bg-foreground-800 text-foreground-400 text-xs">合作站点D</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2024-2026 黑料网下载 | 黑料网在线观看与黑料在线 | 黑料视频在线播放高清
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}